import { LOYALTY_CONST, PAGE_URI } from '../../constants';
import { IAriesReservation, IAriesRewards, ILoyaltyKeys, SessionData } from '../../session';
import { getMemState } from '../datalayerHelpers';
import { canUseDOM } from '../../helpers';

export function getLoyaltyKeys(sessionData: SessionData, pageUri: string) {
  const loyaltyKeys: Partial<ILoyaltyKeys> = Object.seal({
    mr_id_alternate: '',
    mr_prof_authentication_state: '',
    mr_enrolled: '',
    mr_enrollment_source: '',
    mr_isLinkedUser: '',
    mr_enrollment_form: canUseDOM ? window.location.search?.split('=')[1] || '' : '',
  });

  const AriesRewards: Partial<IAriesRewards> | undefined = sessionData?.data?.AriesRewards;
  const AriesReservation: Partial<IAriesReservation> | undefined = sessionData?.data?.AriesReservation;

  /**
   * Logic for mr_enrolled & mr_enrollment_source
   */
  switch (true) {
    case AriesRewards?.sweepStakeEnrollment === LOYALTY_CONST.SUCCESS:
      loyaltyKeys.mr_enrollment_source = AriesRewards?.mr_enrollment_source;
      loyaltyKeys.mr_enrolled = LOYALTY_CONST.TRUE;
      break;
    case !!AriesRewards?.mr_enrollment_source:
      loyaltyKeys.mr_enrollment_source = AriesRewards?.mr_enrollment_source;
      if (AriesRewards?.mr_enrolled) {
        loyaltyKeys.mr_enrolled = LOYALTY_CONST.TRUE;
      } else if (AriesRewards?.mr_enrollment_source === LOYALTY_CONST.FAILUTE) {
        loyaltyKeys.mr_enrolled = LOYALTY_CONST.FALSE;
      }
      break;
    case !!AriesRewards:
      AriesRewards?.rewardsNumber && AriesRewards?.enrollmentStatus && (loyaltyKeys.mr_enrolled = LOYALTY_CONST.TRUE);
      break;
    case !!AriesReservation:
      AriesReservation?.rewardsNumber &&
        AriesReservation?.enrollmentStatus &&
        Boolean(AriesReservation?.passwordLessEnrollment) &&
        (loyaltyKeys.mr_enrolled = LOYALTY_CONST.INACTIVE);
      break;
  }

  const memState = getMemState(sessionData);
  if (memState !== 'remembered') {
    loyaltyKeys.mr_isLinkedUser = String(sessionData?.data?.AriesAuth?.SocialLogin?.isLinkedUser ?? 'false');
  } else if (pageUri?.includes(PAGE_URI.availabilityCalendar) && sessionData?.data?.AriesCommon?.mr_isLinkedUser) {
    loyaltyKeys.mr_isLinkedUser = sessionData?.data?.AriesCommon?.mr_isLinkedUser;
  }

  const consumerId = sessionData?.data?.consumerID;
  if (pageUri?.includes(PAGE_URI.default)) {
    if (memState === 'authenticated') {
      loyaltyKeys.mr_id_alternate = consumerId;
    }
  } else {
    loyaltyKeys.mr_id_alternate = consumerId;
  }

  loyaltyKeys.mr_prof_authentication_state = memState;

  // removing empty and undefined keys
  const filteredObj = Object.fromEntries(
    Object.entries(loyaltyKeys).filter(([_, value]) => value != null && value !== '')
  );

  return { ...filteredObj };
}
